const addTrailingSlash = (str) => `${str}`.replace(/\/?$/, '/');
export default addTrailingSlash;